// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
export function qms(): string {
    return 'qms';
}
